import React, { useState } from "react";
import { Clock, ChevronDown, ChevronUp, History } from "lucide-react";
import { StageHistoryEntry } from "../../types";

interface StageHistoryTimelineProps {
  history: StageHistoryEntry[];
}

export const StageHistoryTimeline: React.FC<StageHistoryTimelineProps> = ({ history }) => {
  const [expanded, setExpanded] = useState(false);

  if (!history || history.length === 0) {
    return null;
  }

  const sortedHistory = [...history].sort(
    (a, b) => new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime(),
  );

  return (
    <div className="rounded-lg border border-slate-200/80 bg-slate-50/50 p-3 dark:border-slate-800 dark:bg-slate-900/40">
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="flex w-full items-center justify-between text-xs font-semibold text-slate-700 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
      >
        <span className="flex items-center gap-1.5">
          <History className="h-3.5 w-3.5 text-[#2ba5b5]" />
          <span>Stage History & Audit Trail ({history.length} events)</span>
        </span>
        {expanded ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
      </button>

      {expanded && (
        <div className="mt-3 space-y-2 border-t border-slate-200/60 pt-2.5 dark:border-slate-800/60">
          {sortedHistory.map((entry, idx) => (
            <div key={`${entry.changedAt}-${idx}`} className="flex items-start gap-2.5 text-xs">
              <div className="mt-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-teal-100 text-[#2ba5b5] dark:bg-teal-950">
                <Clock className="h-2.5 w-2.5" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-semibold uppercase text-slate-800 dark:text-slate-200">
                    {entry.stage.replace("_", " ")}
                  </span>
                  <span className="text-[11px] text-slate-400">
                    by {entry.changedBy} on {new Date(entry.changedAt).toLocaleString()}
                  </span>
                </div>
                {entry.note && (
                  <p className="mt-0.5 text-slate-600 dark:text-slate-400 italic">
                    &quot;{entry.note}&quot;
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
